import styled from 'styled-components';


export const UnitContainer = styled.div`
  background-color: var(--admin-body-color);
  border: 1px solid #ededed;
  padding: 15px;

  position: relative;
  margin: 0 0 2vh 0;
  &.clean-top {
    padding-top: 15px;
  }
  &.add-new {
    background-color: #e6f4f177;
    cursor: pointer;
  }
`;

type UnitContainerHeadProps = {
  errors?: unknown;
};

export const UnitContainerHead = styled.div<UnitContainerHeadProps>`
  background-color: ${({errors}) =>
    errors ? 'rgba(255,0,0,.2)' : `var(--admin-secondary-color)AA`};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin: -15px -15px 16px;
  padding: 5px;
  padding-left: 20px;
  padding-right: 70px;
  position: relative;
  > .input-field {
    flex: 1 1 220px;
    width: auto !important;
    margin-left: 0 !important;
  }
  input {
    background-color: transparent !important;
    border-bottom: 1px solid #ccc !important;
  }
  &:before {
    color: var(--admin-text-color);
    cursor: grab;
    content: '\f58e';
    font-family: 'Font Awesome 6 Pro';
    left: 10px;
    margin-top: -10px;
    position: absolute;
    top: 50%;
  }
  @media screen and (max-width: 768px) {
    & {
      padding-right: 40px;
    }
  }
`;

export const UnitContainerContentEmpty = styled.div`
  color: #777777;
  font-size: 1.33em;
  text-align: center;
  &:before {
    content: '\f067';
    font-family: 'Font Awesome 6 Pro';
    margin-right: 10px;
  }
`;

export const UnitContainerMinified = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 14px;
  background-color: #fafbfc;
  border: 1px solid #e3e7eb;
  border-left: 4px solid var(--admin-secondary-color, #48716d);
  border-radius: 8px;
  color: #263238;
`;

export const UnitSummaryThumbnail = styled.div`
  width: 112px;
  aspect-ratio: 16 / 9;
  flex: 0 0 112px;
  overflow: hidden;
  border-radius: 6px;
  background: linear-gradient(135deg, #293e49, #668c91);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const UnitSummaryDetails = styled.div`
  flex: 1 1 160px;
  min-width: 0;
  strong {
    display: block;
    overflow-wrap: anywhere;
    font-size: 16px;
    margin-bottom: 8px;
  }
`;

export const UnitSummaryBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  span {
    padding: 3px 8px;
    border-radius: 12px;
    background: #e8f1f0;
    color: #254b49;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const UnitDetailsButton = styled.button`
  padding: 9px 14px;
  border: 1px solid #48716d;
  border-radius: 6px;
  background: transparent;
  color: var(--admin-text-color, #254b49);
  cursor: pointer;
  font-weight: 600;
  &:hover {
    background: #e8f1f0;
    color: #254b49;
  }
  &:focus-visible {
    outline: 2px solid #48716d;
    outline-offset: 3px;
  }
`;

export const UnitSelectFields = styled.div`
  display: flex;
  flex: 1 1 340px;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0;
`;

export const UnitSelectField = styled.label`
  display: block;
  flex: 1 1 160px;
  min-width: 0;
  color: var(--admin-text-color, #333);
  font-size: 14px;
  > span {
    display: block;
    margin-bottom: 6px;
  }
  input {
    height: auto !important;
    margin: 0 !important;
    box-shadow: none !important;
  }
`;
